import styled from 'styled-components';

export const Container = styled.div<{ withMargin: boolean }>`
  padding-top: ${({ withMargin }) => (withMargin ? '40px' : 0)};
`;

export const CustomTimeframeViewWrapper = styled.div`
  padding-top: 14px;
`;
